module.exports = __webpack_public_path__ + "static/media/nfl.57dcfd96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/nfl.svg
// module id = 607
// module chunks = 0